import React, { Component } from "react";
import AutoComponent from "../common/AutoComponent";
import PageName from "../common/PageName";
import { Button } from "reactstrap";
import { fetchData } from "../common/networkRequests";
import { shouldDisplayComponent } from "../oro-module/commonFunctions";


class FilterContent extends Component {
  constructor(props) {
    super(props);
    this.state = { isSearch: false };
  }

  handleFilter = () => {
    let { LocalVars, pageData, ShowSidebar } = this.props.parentState;
    // console.log(ShowSidebar)
    LocalVars["showFilter"] = false;
    LocalVars["ShowHistory"] = false;
    this.props.liftGlobalState(
      { name: "ShowSidebar" },
      false
    );
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
    this.props.liftGlobalState({ name: "pageData" }, {});

  };


  createComponent = (allc, localpage) => {
    let { currentWizard, showFilter } = this.props.parentState.LocalVars;
    let { fileFolder, showButtons, formElements, currentPage, themecolor, pageData, isSpinnerShow } = this.props.parentState;
    let x;
    !themecolor ? themecolor = "default" : x = 0;
    return (
      // <div className="col-12 noprint" id="formcontentheight">
      <div
        style={{ marginTop: 0 }}
        className={`SearchArea form-section ${themecolor}-form-section ${this.props.parentState.LocalVars.formSubmittedClass
          }`}
      >
        <div
          style={{
            marginRight: 0,
            paddingRight: 0,
            marginLeft: 0,
            paddingLeft: 0
          }}
          className="row col-sm-12 sub-form-section">
          {allc.map((component, index) => {
            // let conditionalRender = 'no';
            // Check if contains subComponents.
            if (!component.tag) {
              if (component.subComponents) {
                return (
                  <div key={index} className={`nopadding ${component.widths}`}>
                    {this.createComponent(component.subComponents)}
                  </div>
                );
              } else {
                let { shouldRender, conditionalRender } = shouldDisplayComponent({ current: this, pageData, component, allData: this.props.parentState });
                if (shouldRender == 1) {
                  if (
                    this.props.parentState &&
                    this.props.parentState.pageData[component.name]
                  ) {
                    var value = this.props.parentState.pageData[component.name];
                  } else {
                    var value = "";
                  }

                  return (
                    <AutoComponent
                      component={component}
                      liftState={this.props.liftState}
                      liftGlobalState={this.props.liftGlobalState}
                      parentStateGlobal={this.props.parentState}
                      parentState={this.props.parentState}
                      parentProps={this.props.parentProps}
                      key={index}
                      index={index}
                      conditionalRender={conditionalRender}
                    />
                  );
                }
              }
            }

          })}
        </div>

        {/* {(showButtons.search || localpage) &&
          (<div className="row">
            {!isSpinnerShow && <Button
              outline
              className={`col-2 offset-5 black-submit-button`}
              id="main-form-submit-button"
              color="success"
              onClick={() => handleSearch(this)}
            >
              <span>Search</span>

            </Button>}

            {isSpinnerShow &&
              <div className="col-2 offset-5">
                <img height="50" width="50" src="/images/gif/spinner-min.gif" /></div>
            }
          </div>)
        } */}
      </div>
    );
  };

  render() {
    let {
      fileFolder,
      formState,
      otherPage, showButtons, LocalVars,
      localpage,
      currentPage,
      openControls
    } = this.props.parentState;

    if (localpage) {
      currentPage = localpage;
    }

    if (openControls.length > 0) { currentPage = openControls[openControls.length - 1]['fastpath']; }

    // let filter={};
    // if(this.props.parentState.formElements){
    // }
    let filter = this.props.parentState.formElements[currentPage].filter;

    return this.createComponent(filter, localpage);
  }
}

export default FilterContent;
